module.exports = __webpack_public_path__ + "static/img/contract_bg.986ff59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dingdan/contract_bg.png
// module id = fP4r
// module chunks = 1